import { render, staticRenderFns } from "./catchall.vue?vue&type=template&id=40ba04e6&scoped=true&"
import script from "./catchall.vue?vue&type=script&lang=js&"
export * from "./catchall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40ba04e6",
  null
  
)

export default component.exports